import Vue from 'vue'
import Router from 'vue-router'

const Login = ()=> import('@/components/Login');
const CheckLogin = ()=> import('@/components/CheckLogin');
const Error = ()=> import('@/components/Error')


const UserList = ()=> import('@/components/userList/Main')
const UserEdit = ()=> import('@/components/userEdit/Main')
const Calendar = ()=> import('@/components/calendar/Main')
const Settings = ()=> import('@/components/settings/Main')

Vue.use(Router)

const router = new Router({
	  routes: [
		    {
		    	path: '/',
		    	component: UserList,
		    	meta: {requiresAuth: true}
		    },
		    {
		    	path: '/login',
		    	component: Login,
		    	meta: {requiresAuth: false}
		    },
		    {
		        path: '/checkLogin',
		        component: CheckLogin,
		        meta: {requiresAuth: false}
		    },
		    {
		      path: '/userList/',
		      component: UserList,
		      meta: {requiresAuth: true}
		    },
		    {
		      path: '/userEdit/:id',
		      component: UserEdit,
		      meta: {requiresAuth: true}
		    },
			{
			  path: '/calendar/',
			  component: Calendar,
			  meta: {requiresAuth: true}
			},
			{
			  path: '/settings/',
			  component: Settings,
			  meta: {requiresAuth: true}
			},
		    {
		      path: "*",
		      component: Error,
			  meta: {requiresAuth: true}
		    }
		  ]
		});


router.beforeEach((to, from, next) => {
	if(!Vue.$auth.isLoggedIn()){
		if(!to.matched[0].meta.requiresAuth) {
			next();
		} else {
			next({
				path: '/checkLogin',
	        	query: {redirect: to.fullPath}
			})
		}
	} else {
		if(!to.matched[0].meta.requiresAuth) {
			next({
				path: from.fullPath
			});
		} else {
			next();
		}
	}
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js